
import React from 'react';
import { cn } from '@/lib/utils';

interface DashboardCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'blue' | 'purple' | 'amber' | 'green' | 'indigo';
  noPadding?: boolean;
  noAnimation?: boolean;
  allowOverflow?: boolean;
}

const DashboardCard = ({ 
  children, 
  className, 
  variant = 'default',
  noPadding = false,
  noAnimation = false,
  allowOverflow = false,
  ...props 
}: DashboardCardProps) => {
  // Border styles removed for a cleaner look
  const variantBorderStyles = {
    default: '',
    blue: '',
    purple: '',
    amber: '',
    green: '',
    indigo: '',
  };

  // Variant colors are now handled by the glassmorphism effect
  // Keeping the variant prop for backward compatibility
  const variantGradientStyles = {
    default: '',
    blue: '',
    purple: '',
    amber: '',
    green: '',
    indigo: '',
  };

  return (
    <div
      className={cn(
        "relative rounded-2xl",
        allowOverflow ? "overflow-visible" : "overflow-hidden",
        !noPadding && "p-6",
        className
      )}
      style={{ borderRadius: '1rem' }} // Explicit border-radius
      {...props}
    >
      {/* Base Gradient (Bottom Layer) */}
      <div className={cn(
        "absolute inset-0 -z-10 rounded-2xl",
        "bg-gradient-to-br from-white/60 via-white/30 to-white/10",
        "dark:from-black/40 dark:to-black/20"
      )} />
      
      {/* Glass effect */}
      <div className="absolute inset-0 backdrop-blur-xl backdrop-saturate-150 -z-10 rounded-2xl" />
      
      {/* Content */}
      <div className="relative rounded-2xl">
        {children}
      </div>
    </div>
  );
  
};

export default DashboardCard;
